// Homepage banner slider
function initHomepageSlider() {
  var sliderElement = document.querySelector('.hp_banner_slider');
  if (!sliderElement) {
    return;
  }

  var splide = new Splide('.hp_banner_slider', {
    type: 'fade',
    perPage : 1,
    focus   : 'center',
    autoplay: false,
    rewind  : true,
    drag    : true,
    arrows   : false,
    pagination   : false,
  });

  function loadSlideVideoSources(video) {
    var unloaded = video.querySelectorAll('source[data-src]');
    if (!unloaded.length) return false;
    unloaded.forEach(function (s) {
      s.src = s.getAttribute('data-src');
      s.removeAttribute('data-src');
    });
    video.load();
    return true;
  }

  function playActiveSlideVideo() {
    var active = splide.Components.Slides.getAt(splide.index);
    var activeSlide = active ? active.slide : null;
    var allVideos = sliderElement.querySelectorAll('.slider-video');

    allVideos.forEach(function (video) {
      if (activeSlide && activeSlide.contains(video)) {
        video.muted = true;
        video.setAttribute('muted', 'muted');
        video.setAttribute('playsinline', 'playsinline');
        video.currentTime = 0;
        var needsLoad = loadSlideVideoSources(video);
        if (needsLoad) {
          video.addEventListener('canplay', function onCanPlay() {
            video.removeEventListener('canplay', onCanPlay);
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
          });
        } else {
          var playPromise = video.play();
          if (playPromise && playPromise.catch) {
            playPromise.catch(function () {});
          }
        }
      } else {
        video.pause();
        video.currentTime = 0;
      }
    });
  }

  sliderElement.querySelectorAll('.slider-video').forEach(function (video) {
    video.addEventListener('ended', function () {
      var active = splide.Components.Slides.getAt(splide.index);
      var activeSlide = active ? active.slide : null;
      if (activeSlide && activeSlide.contains(video)) {
        splide.go('>');
      }
    });
  });

  splide.on('mounted moved', playActiveSlideVideo);
  splide.mount();
}

// Homepage banner video controls (audio + fullscreen)
function initHomepageVideoControls() {
  var bannerContainer = document.querySelector('.hp_banner_container');
  var video           = document.getElementById('video');
  var audioBtn        = document.getElementById('videoAudioBtn');
  var fullscreenBtn   = document.getElementById('videoFullscreenBtn');

  if (!video || !audioBtn || !fullscreenBtn || !bannerContainer) return;

  var audioOnIcon  = audioBtn.querySelector('.icon-audio-on');
  var audioOffIcon = audioBtn.querySelector('.icon-audio-off');
  var enterFsIcon  = fullscreenBtn.querySelector('.icon-enter-fullscreen');
  var exitFsIcon   = fullscreenBtn.querySelector('.icon-exit-fullscreen');

  // ── video-ready: fades out the poster image once video has data ──────────
  var videoReadyDone = false;
  function markVideoReady() {
    if (videoReadyDone) return;
    videoReadyDone = true;
    bannerContainer.classList.add('video-ready');
  }
  var readyTimer = window.setTimeout(markVideoReady, 8000);
  video.addEventListener('canplay',  function () { window.clearTimeout(readyTimer); markVideoReady(); });
  video.addEventListener('playing',  function () { window.clearTimeout(readyTimer); markVideoReady(); });
  if (video.readyState >= 3) { window.clearTimeout(readyTimer); markVideoReady(); }

  // ── audio ────────────────────────────────────────────────────────────────
  function syncAudio() {
    if (audioOnIcon)  audioOnIcon.classList.toggle('hidden',  video.muted);
    if (audioOffIcon) audioOffIcon.classList.toggle('hidden', !video.muted);
  }
  audioBtn.addEventListener('click', function () {
    video.muted = !video.muted;
    if (video.paused) video.play().catch(function () {});
    syncAudio();
  });

  // ── fullscreen ────────────────────────────────────────────────────────────
  // iOS Safari's native player does NOT set document.fullscreenElement,
  // so we track it with a separate flag via webkitbeginfullscreen/webkitendfullscreen.
  var iosNativeFs = false;

  function inFullscreen() {
    return !!(document.fullscreenElement || document.webkitFullscreenElement) || iosNativeFs;
  }

  function syncFsIcons() {
    var fs = inFullscreen();
    if (enterFsIcon) enterFsIcon.classList.toggle('hidden',  fs);
    if (exitFsIcon)  exitFsIcon.classList.toggle('hidden',  !fs);
  }

  fullscreenBtn.addEventListener('click', function () {
    if (inFullscreen()) {
      if (document.exitFullscreen)            document.exitFullscreen();
      else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
      else if (video.webkitExitFullscreen)    video.webkitExitFullscreen();
      return;
    }

    // iOS Safari: webkitEnterFullscreen opens the native video player.
    // It is completely separate from the page DOM — layout, scroll state,
    // and touch handlers are unaffected.
    if (video.webkitEnterFullscreen) {
      video.webkitEnterFullscreen();
      return;
    }

    // Android / desktop: fullscreen the whole banner container so the
    // slider, overlay, and controls are all included in the fullscreen view.
    if (bannerContainer.requestFullscreen)            bannerContainer.requestFullscreen();
    else if (bannerContainer.webkitRequestFullscreen) bannerContainer.webkitRequestFullscreen();
  });

  // iOS Safari: webkitbeginfullscreen / webkitendfullscreen fire on the video element.
  video.addEventListener('webkitbeginfullscreen', function () {
    iosNativeFs = true;
    syncFsIcons();
  });

  video.addEventListener('webkitendfullscreen', function () {
    iosNativeFs = false;
    syncFsIcons();
    // iOS always pauses the inline video when the native player closes.
    // video.load() re-initialises the element (necessary when iOS has consumed
    // the media buffer during native playback), then play() restarts it.
    // Both calls are within the "Done" tap's user-gesture context so iOS allows them.
    video.load();
    video.play().catch(function () {});
  });

  // Android / desktop: standard Fullscreen API events on document.
  document.addEventListener('fullscreenchange', function () {
    syncFsIcons();
    // Some browsers pause video on fullscreen exit — resume if needed.
    if (!document.fullscreenElement && !document.webkitFullscreenElement) {
      if (video.paused) video.play().catch(function () {});
    }
  });
  document.addEventListener('webkitfullscreenchange', function () {
    syncFsIcons();
    if (!document.fullscreenElement && !document.webkitFullscreenElement) {
      if (video.paused) video.play().catch(function () {});
    }
  });

  // ── resilience ────────────────────────────────────────────────────────────
  // Resume if browser throttled the off-screen video.
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting && video.paused) {
        video.play().catch(function () {});
      }
    }, { threshold: 0.2 });
    obs.observe(bannerContainer);
  }

  // Resume when the user returns to this tab.
  document.addEventListener('visibilitychange', function () {
    if (document.hidden || !video.paused) return;
    var r = bannerContainer.getBoundingClientRect();
    if (r.top < window.innerHeight && r.bottom > 0) {
      video.play().catch(function () {});
    }
  });

  // Mute background video when section 2 activates.
  document.addEventListener('section2Activated', function () {
    if (!video.muted) { video.muted = true; syncAudio(); }
  });

  video.addEventListener('contextmenu', function (e) { e.preventDefault(); });

  // ── init ──────────────────────────────────────────────────────────────────
  syncAudio();
  syncFsIcons();
  // iOS ignores the autoplay attribute — explicit play() is required.
  video.play().catch(function () {});
}

// Homepage section 2 content reveal after transition
function initHomepageSection2Reveal() {
  var section2 = document.getElementById('section2');
  var contentBlock = section2 ? section2.querySelector('.hp_content_block') : null;
  var headingLines = contentBlock ? contentBlock.querySelectorAll('.heading-1') : [];

  if (
    !section2 ||
    !section2.classList.contains('hp_content_section') ||
    !contentBlock ||
    !headingLines.length ||
    typeof gsap === 'undefined'
  ) {
    return;
  }

  var animatedWords = [];
  var textTween = null;

  headingLines.forEach(function (line) {
    if (line.getAttribute('data-words-ready') === 'true') {
      animatedWords = animatedWords.concat(Array.prototype.slice.call(line.querySelectorAll('.word')));
      return;
    }

    var text = (line.textContent || '').trim();
    if (!text) return;

    var words = text.split(/\s+/);
    line.innerHTML = words
      .map(function (word) {
        return '<span class="word" style="display:inline-block; will-change:transform,opacity;">' + word + '</span>';
      })
      .join(' ');
    line.setAttribute('data-words-ready', 'true');
    animatedWords = animatedWords.concat(Array.prototype.slice.call(line.querySelectorAll('.word')));
  });

  if (!animatedWords.length) {
    return;
  }

  gsap.set(animatedWords, {
    yPercent: 100,
    opacity: 0
  });

  function showContent() {
    section2.classList.add('content-visible');
    if (textTween) {
      textTween.kill();
    }
    textTween = gsap.to(animatedWords, {
      yPercent: 0,
      opacity: 1,
      stagger: 0.05,
      duration: 0.6,
      ease: 'power2.out'
    });
  }

  function hideContent() {
    if (textTween) {
      textTween.kill();
      textTween = null;
    }
    gsap.set(animatedWords, { yPercent: 100, opacity: 0 });
    section2.classList.remove('content-visible');
  }

  document.addEventListener('section2Activated', showContent);
  document.addEventListener('section1Activated', hideContent);
  document.addEventListener('homepageSection2ReverseStart', hideContent);

  // If section2 is already active on load (hash/refresh cases), reveal immediately.
  if (document.body.classList.contains('section2-active')) {
    showContent();
  }
}

// Homepage section 2 craftmanship video scroll-in + pin
function initHomepageSection2VideoScroll() {

  var section2 = document.getElementById('section2');
  var videoWrap = section2 ? section2.querySelector('.hp_craftmanship_video_wrap') : null;
  var video = videoWrap ? videoWrap.querySelector('.hp_craftmanship_video') : null;
  var labelGroup = videoWrap ? videoWrap.querySelector('.hp_craftmanship_label_group') : null;
  var contentBlock = section2 ? section2.querySelector('.hp_content_block') : null;
  var transitionWrapper = section2 ? section2.closest('.homepage-transition-wrapper') : null;
  var overlay = transitionWrapper ? transitionWrapper.querySelector('.overlay') : null;

  if (!section2 || !videoWrap || !video || typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    return;
  }

  if ((window.innerWidth || document.documentElement.clientWidth || 375) <= 768) {
    return;
  }

  if (typeof gsap.registerPlugin === 'function') {
    gsap.registerPlugin(ScrollTrigger);
  }

  var existingTrigger = ScrollTrigger.getById('hp-section2-video-pin');
  if (existingTrigger) {
    existingTrigger.kill();
  }
  var existingOverlayTrigger = ScrollTrigger.getById('hp-section2-overlay-pin');
  if (existingOverlayTrigger) {
    existingOverlayTrigger.kill();
  }

  var overlayPinTrigger = null;
  var videoAspectRatio = 600 / 1050;

  function getCraftPinEnd() {
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 800;
    return '+=' + Math.round(viewportHeight * 1.8);
  }

  function getVideoSizes() {
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 375;
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 800;
    var isMobile = viewportWidth <= 768;
    var startWidth = isMobile ? 180 : 250;
    var startHeight = isMobile ? 220 : 300;

    var targetWidth = isMobile ? viewportWidth : 1040;
    var targetHeight = isMobile ? viewportHeight : 600;

    return {
      startWidth: startWidth,
      startHeight: startHeight,
      targetWidth: targetWidth,
      targetHeight: targetHeight
    };
  }

  function createOverlayPinTrigger() {
    if (!overlay || overlayPinTrigger) return;
    overlayPinTrigger = ScrollTrigger.create({
      id: 'hp-section2-overlay-pin',
      trigger: section2,
      start: 'top top',
      end: getCraftPinEnd,
      pin: overlay,
      pinSpacing: false,
      invalidateOnRefresh: true
    });
  }

  function killOverlayPinTrigger() {
    if (!overlayPinTrigger) return;
    overlayPinTrigger.kill();
    overlayPinTrigger = null;
  }

  gsap.set(video, {
    y: window.innerHeight * 0.9,
    width: getVideoSizes().startWidth,
    height: getVideoSizes().startHeight
  });
  if (labelGroup) {
    gsap.set(labelGroup, { autoAlpha: 0 });
  }
  if (contentBlock) {
    gsap.set(contentBlock, { filter: 'blur(0px)' });
  }

  // Header suppression only while the scrub timeline has moved past the start (see onUpdate). Whole-pin isActive would keep the header hidden after reversing the video to progress 0.
  var prevSuppressHeaderForCraftPin = false;

  function syncCraftPinHeaderSuppression(self) {
    var suppressHeader =
      self.isActive &&
      typeof self.progress === 'number' &&
      self.progress > 0.02;
    if (prevSuppressHeaderForCraftPin && !suppressHeader) {
      var headerEl = document.getElementById('header');
      if (headerEl) {
        headerEl.classList.remove('is-hidden');
        headerEl.classList.add('is-visible');
      }
    }
    prevSuppressHeaderForCraftPin = suppressHeader;
    document.body.classList.toggle('hp-craft-video-pin-active', suppressHeader);
  }

  // Discrete step state (0 = hidden, 1 = small visible, 2 = expanded)
  // 3 scroll steps: scroll 1 → appear small, scroll 2 → expand, scroll 3 → exit to next section
  var CRAFT_TOTAL_STEPS = 3;
  var craftStep = 0;
  var craftAnimating = false;
  var craftPinST = null;

  function craftStepThreshold(step) {
    return step / CRAFT_TOTAL_STEPS; // 0.5 for step 1
  }

  function playStepForward() {
    if (craftAnimating || craftStep >= CRAFT_TOTAL_STEPS) return;
    craftAnimating = true;
    var nextStep = craftStep + 1;
    var sizes = getVideoSizes();
    var tl = gsap.timeline({
      onComplete: function () {
        craftAnimating = false;
        craftStep = nextStep;
        // No auto-advance: require a deliberate next scroll gesture to trigger the next step
      }
    });
    if (nextStep === 1) {
      // Scroll 1: small video slides up into view
      tl.to(video, { y: 0, duration: 0.6, ease: 'power2.out' });
    } else if (nextStep === 2) {
      // Scroll 2: video expands to full size
      tl.to(video, { width: sizes.targetWidth, height: sizes.targetHeight, duration: 0.7, ease: 'power2.inOut' });
      if (contentBlock) tl.to(contentBlock, { filter: 'blur(14px)', duration: 0.7, ease: 'none' }, '<');
      if (labelGroup) tl.to(labelGroup, { autoAlpha: 1, duration: 0.4 });
    }
  }

  function playStepBack() {
    if (craftAnimating || craftStep <= 0) return;
    craftAnimating = true;
    var prevStep = craftStep - 1;
    var tl = gsap.timeline({
      onComplete: function () {
        craftAnimating = false;
        craftStep = prevStep;
      }
    });
    if (craftStep === 1) {
      tl.to(video, { y: window.innerHeight * 0.9, duration: 0.4, ease: 'power2.in' });
    } else if (craftStep === 2) {
      var sizes2 = getVideoSizes();
      if (labelGroup) tl.to(labelGroup, { autoAlpha: 0, duration: 0.2 });
      tl.to(video, { width: sizes2.startWidth, height: sizes2.startHeight, duration: 0.5, ease: 'power2.in' });
      if (contentBlock) tl.to(contentBlock, { filter: 'blur(0px)', duration: 0.5, ease: 'none' }, '<');
    }
  }

  craftPinST = ScrollTrigger.create({
    id: 'hp-section2-video-pin',
    trigger: section2,
    start: 'top top',
    end: getCraftPinEnd,
    pin: true,
    pinSpacing: true,
    anticipatePin: 1,
    invalidateOnRefresh: true,
    onUpdate: function (self) {
      syncCraftPinHeaderSuppression(self);
      if (craftAnimating) return;
      var prog = self.progress;
      var dir = self.direction;
      if (dir === 1 && craftStep < CRAFT_TOTAL_STEPS && prog >= craftStepThreshold(craftStep + 1)) {
        playStepForward();
      } else if (dir === -1 && craftStep > 0 && prog < craftStepThreshold(craftStep)) {
        playStepBack();
      }
    },
    onLeave: function () {
      prevSuppressHeaderForCraftPin = false;
      document.body.classList.remove('hp-craft-video-pin-active');
      if (transitionWrapper) {
        transitionWrapper.classList.remove('section2-overlay-persist');
      }
    },
    onLeaveBack: function () {
      craftStep = 0;
      craftAnimating = false;
      gsap.killTweensOf([video, contentBlock, labelGroup]);
      var sizes = getVideoSizes();
      gsap.set(video, { y: window.innerHeight * 0.9, width: sizes.startWidth, height: sizes.startHeight });
      if (contentBlock) gsap.set(contentBlock, { filter: 'blur(0px)' });
      if (labelGroup) gsap.set(labelGroup, { autoAlpha: 0 });
      prevSuppressHeaderForCraftPin = false;
      document.body.classList.remove('hp-craft-video-pin-active');
      var headerEl = document.getElementById('header');
      if (headerEl) {
        headerEl.classList.remove('is-hidden');
        headerEl.classList.add('is-visible');
      }
    },
    onEnterBack: function () {
      if (transitionWrapper) {
        transitionWrapper.classList.add('section2-overlay-persist');
      }
    }
  });

  document.addEventListener('section2Activated', function () {
    createOverlayPinTrigger();
    // Touch devices (iPad) need extra time for Lenis to restart and layout to settle
    // before ScrollTrigger can calculate correct pin positions.
    var refreshDelay = window.matchMedia('(pointer: coarse)').matches ? 300 : 60;
    window.setTimeout(function () {
      ScrollTrigger.refresh();
    }, refreshDelay);
  });

  document.addEventListener('section1Activated', function () {
    killOverlayPinTrigger();
    prevSuppressHeaderForCraftPin = false;
    document.body.classList.remove('hp-craft-video-pin-active');
    var headerEl = document.getElementById('header');
    if (headerEl) {
      headerEl.classList.remove('is-hidden');
      headerEl.classList.add('is-visible');
    }
  });
}

function initHomepageSection2MobileVideo() {
  if ((window.innerWidth || document.documentElement.clientWidth || 375) > 768) {
    return;
  }

  var section2 = document.getElementById('section2');
  var videoWrap = section2 ? section2.querySelector('.hp_craftmanship_video_wrap') : null;
  var video = videoWrap ? videoWrap.querySelector('.hp_craftmanship_video') : null;
  var labelGroup = videoWrap ? videoWrap.querySelector('.hp_craftmanship_label_group') : null;
  var fullscreenBtn = videoWrap ? videoWrap.querySelector('.hp_craft_fullscreen_btn') : null;

  if (!videoWrap || !video) {
    return;
  }

  // No native controls — keep same experience as desktop
  video.removeAttribute('controls');

  var observer = new IntersectionObserver(function (entries) {
    if (entries[0].isIntersecting) {
      videoWrap.classList.add('is-expanded');
      if (labelGroup) labelGroup.classList.remove('is-faded');
    } else {
      videoWrap.classList.remove('is-expanded');
      if (labelGroup) labelGroup.classList.remove('is-faded');
    }
  }, { threshold: 0.3 });

  observer.observe(videoWrap);
}

// Lazy-load craftsmanship video sources.
// Desktop: fires on section2Activated (before GSAP animation plays) so the video
// has time to buffer while it animates into view.
// Fallback: IntersectionObserver covers mobile and any path that skips the event.
function initCraftVideoLazyLoad() {
  var video = document.querySelector('.hp_craftmanship_video');
  if (!video) return;
  var videoLoaded = false;
  function loadSources() {
    if (videoLoaded) return;
    videoLoaded = true;
    var sources = video.querySelectorAll('source[data-src]');
    sources.forEach(function (s) {
      s.src = s.getAttribute('data-src');
      s.removeAttribute('data-src');
    });
    video.load();
  }
  document.addEventListener('section2Activated', loadSources);
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        loadSources();
        observer.disconnect();
      }
    }, { threshold: 0.1 });
    observer.observe(video);
  } else {
    loadSources();
  }
}

// Mobile: turn hp_content_section background white once its bottom 40% reaches the viewport top
function initHpContentSectionMobileBgWhite() {
  if ((window.innerWidth || document.documentElement.clientWidth || 375) > 768) return;

  var section = document.querySelector('.hp_content_section');
  if (!section) return;

  function check() {
    var rect = section.getBoundingClientRect();
    var triggerPoint = rect.top + rect.height * 0.5;
    section.classList.toggle('hp-bg-white', triggerPoint <= 0);
  }

  var rafId = null;
  function onScroll() {
    if (rafId) return;
    rafId = requestAnimationFrame(function () {
      check();
      rafId = null;
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  if (window.lenis) window.lenis.on('scroll', onScroll);
  check();
}

document.addEventListener('DOMContentLoaded', function () {
  initHomepageSlider();
  initHomepageVideoControls();
  initHomepageSection2Reveal();
  initHomepageSection2VideoScroll();
  initHomepageSection2MobileVideo();
  initHpContentSectionMobileBgWhite();
  initCraftVideoLazyLoad();
});


// ===============================
// Homepage Collection Slider (Splide)
// ===============================
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const collectionSlider = document.querySelector(".our-collection-slider");
    if (!collectionSlider) return;

    function loadCollectionImage(img) {
      if (!img || !img.dataset.src) return;
      img.src = img.dataset.src;
      img.removeAttribute("data-src");
    }

    function loadVisibleCollectionImages() {
      const visibleSlides = collectionSlider.querySelectorAll(".splide__slide.is-visible");
      visibleSlides.forEach(function (slide) {
        const img = slide.querySelector("img[data-src]");
        loadCollectionImage(img);
      });
    }

    function initCollectionSlider() {
      const slideCount = collectionSlider.querySelectorAll(".splide__slide").length;
      const isMobile = window.matchMedia("(max-width: 768px)").matches;
      const perPage = isMobile ? 1 : 4;
      const canLoop = slideCount > perPage;

      const splide = new Splide(collectionSlider, {
        updateOnMove: true,
        type: canLoop ? "loop" : "slide",
        perPage: perPage,
        perMove: 1,
        focus: "center",
        arrows: slideCount > 1,
        pagination: false,
        autoplay: canLoop,
        interval: 3000,
        speed: 1500,
        pauseOnHover: false,
        pauseOnFocus: false,
        gap: "2rem",
        breakpoints: {
          768: {
            perPage: 1,
            gap: "0.75rem",
            padding: slideCount > 1 ? "18%" : 0,
            arrows: false
          }
        }
      });

      splide.on("mounted moved", function () {
        loadVisibleCollectionImages();
      });

      splide.mount();
      loadVisibleCollectionImages();
    }

    if ("IntersectionObserver" in window) {
      const collectionObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              initCollectionSlider();
              collectionObserver.unobserve(collectionSlider);
            }
          });
        },
        { threshold: 0.2 }
      );

      collectionObserver.observe(collectionSlider);
    } else {
      initCollectionSlider();
    }
  });
})();

// ===============================
// Homepage Luxury Experience Awards Slider
// ===============================
(function () {
    document.addEventListener( 'DOMContentLoaded', function () {
      const awardsSlider = document.querySelector('.hp-le-awards');
      if (!awardsSlider) return;

      const slideCount = awardsSlider.querySelectorAll('.splide__slide').length;
      const shouldSlide = slideCount > 3;
      const centerIndex = Math.floor(slideCount / 2);

      new Splide(awardsSlider, {
        type: shouldSlide ? 'loop' : 'slide',
        perPage: 3,
        perMove: 1,
        focus: 'center',
        start: centerIndex,
        gap: '50px',
        fixedWidth: '170px',
        speed: 1000,
        easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
        arrows: false,
        pagination: false,
        autoplay: shouldSlide,
        interval: 3000,
        pauseOnHover: shouldSlide,
        drag: shouldSlide,
        breakpoints: {
          768: {
            perPage: 1,
            perMove: 1,
            fixedWidth: false,
            type: 'loop',
            arrows: false,
            autoplay: slideCount > 1,
            drag: true
          }
        }
      }).mount();
    } );
})();

// ===============================
// Homepage Experience Section: Dark (full opacity) until top 20%, then animate to Light
// ===============================
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const section = document.querySelector(".hp_exp_center");
    const bannerDark = document.querySelector(".hp_exp_center .hp-exp-banner-dark");
    const bannerLight = document.querySelector(".hp_exp_center .hp-exp-banner-light");

    if (!section || !bannerDark || !bannerLight) return;

    bannerDark.style.opacity = "1";
    bannerLight.style.opacity = "0";

    const threshold = 0.2;
    let isLight = false;

    function updateBanner() {
      const rect = section.getBoundingClientRect();
      const top = rect.top;
      const atTop = top <= window.innerHeight * threshold;

      if (atTop && !isLight) {
        isLight = true;
        bannerDark.style.transition = "opacity 0.8s ease";
        bannerLight.style.transition = "opacity 0.8s ease";
        bannerDark.style.opacity = "0";
        bannerLight.style.opacity = "1";
      } else if (!atTop && isLight) {
        isLight = false;
        bannerDark.style.transition = "opacity 0.8s ease";
        bannerLight.style.transition = "opacity 0.8s ease";
        bannerDark.style.opacity = "1";
        bannerLight.style.opacity = "0";
      } else if (!atTop) {
        bannerDark.style.transition = "none";
        bannerLight.style.transition = "none";
        bannerDark.style.opacity = "1";
        bannerLight.style.opacity = "0";
      }
    }

    const onScroll = () => requestAnimationFrame(updateBanner);

    window.addEventListener("scroll", onScroll, { passive: true });
    if (window.lenis) window.lenis.on("scroll", onScroll);
    window.addEventListener("resize", onScroll);

    updateBanner();
  });
})();

// ===============================
// Homepage Luxury Experience Cursor
// ===============================
(function () {
    document.addEventListener("DOMContentLoaded", function () {
      const luxurySection = document.querySelector(".hp_exp_center");
      const luxuryCursor = document.getElementById("luxuryCursor");
      const bookButtons = document.querySelectorAll(".js-book-btn");
  
      if (!luxurySection || !luxuryCursor || !window.matchMedia("(min-width: 1024px)").matches) return;
  
      const CURSOR_SIZE = 90;
      const offset = CURSOR_SIZE / 2;
      let lastClientX = null, lastClientY = null;
      let mouseX = 0, mouseY = 0;
      let cursorX = 0, cursorY = 0;
      let mouseInside = false;
      let loopId = null;
  
      const rectsOverlap = (a, b) => {
        return !(a.right < b.left || b.right < a.left || a.bottom < b.top || b.bottom < a.top);
      };
  
      const updateCursorPosition = () => {
        if (!mouseInside) return;
  
        cursorX += (mouseX - cursorX) * 0.15;
        cursorY += (mouseY - cursorY) * 0.15;
  
        luxuryCursor.style.transform = `translate3d(${cursorX}px, ${cursorY}px, 0)`;
  
        // If cursor overlaps any Book a Visit button, pass clicks through so the button works
        const cursorRect = {
          left: cursorX,
          top: cursorY,
          right: cursorX + CURSOR_SIZE,
          bottom: cursorY + CURSOR_SIZE
        };
        let overButton = false;
        bookButtons.forEach((btn) => {
          const r = btn.getBoundingClientRect();
          if (rectsOverlap(cursorRect, r)) overButton = true;
        });
        if (overButton) {
          luxuryCursor.style.pointerEvents = "none";
          luxuryCursor.style.opacity = "0";
        } else {
          luxuryCursor.style.pointerEvents = "auto";
          luxuryCursor.style.opacity = "";
        }
  
        loopId = requestAnimationFrame(updateCursorPosition);
      };
  
      luxurySection.addEventListener("mouseenter", (e) => {
        if (!isSectionInView()) return;
  
        lastClientX = e.clientX;
        lastClientY = e.clientY;
        showLuxuryCursor(e.clientX, e.clientY);
      });
  
      luxurySection.addEventListener("mousemove", (e) => {
        if (!mouseInside) return;
        lastClientX = e.clientX;
        lastClientY = e.clientY;
        mouseX = e.clientX - offset;
        mouseY = e.clientY - offset;
      });
  
      luxurySection.addEventListener("mouseleave", () => {
        hideLuxuryCursor();
      });
  
      // Click on cursor redirects to Experience MCI page only (Book a Visit button goes to #book-a-visit)
      luxuryCursor.style.cursor = "pointer";
      luxuryCursor.addEventListener("click", (e) => {
        e.preventDefault();
        const url = luxuryCursor.getAttribute("data-experience-url") || (window.location.origin + "/experience-mci/");
        window.location.href = url;
      });
  
      // Add hover events to book buttons to fade out cursor and let clicks reach the button
      bookButtons.forEach(button => {
        button.addEventListener("mouseenter", () => {
          luxuryCursor.style.opacity = "0";
          luxuryCursor.style.transition = "opacity 0.3s ease";
          luxuryCursor.style.pointerEvents = "none";
        });
  
        button.addEventListener("mouseleave", () => {
          luxuryCursor.style.opacity = "";
          luxuryCursor.style.transition = "";
          luxuryCursor.style.pointerEvents = "";
        });
      });

      document.addEventListener("mousemove", (e) => {
        lastClientX = e.clientX;
        lastClientY = e.clientY;
      });
  
      // Hide cursor when section scrolls out of view
      let scrollRaf = null;
      window.addEventListener("scroll", () => {
        if (scrollRaf) return;
        scrollRaf = requestAnimationFrame(() => {
          syncCursorToSection();
          scrollRaf = null;
        });
      }, { passive: true });

      window.addEventListener("resize", syncCursorToSection);
  
      function isSectionInView() {
        const rect = luxurySection.getBoundingClientRect();
        const windowHeight = window.innerHeight;
  
        const threshold = windowHeight * 0.5; // middle 50%
  
        return rect.top < threshold && rect.bottom > threshold;
      }

      function isPointerInsideSection(x, y) {
        const rect = luxurySection.getBoundingClientRect();
        return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
      }

      function syncCursorToSection() {
        if (!isSectionInView() || lastClientX === null || lastClientY === null) {
          hideLuxuryCursor();
          return;
        }

        if (isPointerInsideSection(lastClientX, lastClientY)) {
          showLuxuryCursor(lastClientX, lastClientY);
        } else {
          hideLuxuryCursor();
        }
      }
  
      function showLuxuryCursor(x, y) {
        mouseInside = true;
        luxuryCursor.classList.add("show");
        luxuryCursor.classList.remove("hide");
  
        mouseX = x - offset;
        mouseY = y - offset;
        cursorX = mouseX;
        cursorY = mouseY;
        luxuryCursor.style.transform = `translate3d(${cursorX}px, ${cursorY}px, 0)`;
  
        if (!loopId) {
          loopId = requestAnimationFrame(updateCursorPosition);
        }
      }
  
      function hideLuxuryCursor() {
        mouseInside = false;
        luxuryCursor.classList.remove("show");
        luxuryCursor.classList.add("hide");
  
        if (loopId) {
          cancelAnimationFrame(loopId);
          loopId = null;
        }
  
        luxuryCursor.style.transform = "translate3d(-9999px, -9999px, 0)";
        luxuryCursor.style.pointerEvents = "";
        luxuryCursor.style.opacity = "";
      }
    });
})();

// ===============================
// Homepage MCI Creation Slider (Splide)
// Uses custom pagination bullets instead of Splide's default pagination.
// ===============================
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const projectSlider = document.querySelector(".mci-creation-slider");
    if (!projectSlider) return;
    const fixedTitle = document.getElementById("hpMciCreationFixedTitle");
    const customPagination = document.querySelector(".hp-mci-creation-pagination");

    let sliderInitialized = false;

    function initProjectSlider() {
      if (sliderInitialized) return;
      sliderInitialized = true;

      const splide = new Splide(projectSlider, {
        type: "loop",
        padding: "20%",
        autoplay: true,
        interval: 3000,
        pauseOnHover: false,
        speed: 2000,
        arrows: true,
        pagination: false,
        breakpoints: {
          768: {
            perPage: 1,
            padding: "5%",
            arrows: false
          }
        }
      });

      splide.mount();

      if (customPagination) {
        const slides = projectSlider.querySelectorAll(".splide__slide:not(.splide__slide--clone)");
        const bullets = [];

        customPagination.innerHTML = "";

        function setActiveTitle(activeIndex) {
          if (!fixedTitle || !slides[activeIndex]) return;
          fixedTitle.textContent = slides[activeIndex].getAttribute("data-slide-title") || "";
        }

        function setActiveBullet(activeIndex) {
          bullets.forEach(function (bullet, index) {
            const isActive = index === activeIndex;
            bullet.classList.toggle("is-active", isActive);
            bullet.setAttribute("aria-current", isActive ? "true" : "false");
          });
        }

        slides.forEach(function (_, index) {
          const bullet = document.createElement("button");
          bullet.type = "button";
          bullet.className = "hp-mci-creation-pagination__bullet";
          bullet.setAttribute("aria-label", "Go to slide " + (index + 1));

          bullet.addEventListener("click", function () {
            splide.go(index);
          });

          customPagination.appendChild(bullet);
          bullets.push(bullet);
        });

        setActiveTitle(splide.index);
        setActiveBullet(splide.index);

        splide.on("moved", function (newIndex) {
          setActiveTitle(newIndex);
          setActiveBullet(newIndex);
        });
      }

      const autoplay = splide.Components.Autoplay;
      if (autoplay) {
        let isInBottomHoverZone = false;

        function setAutoplayPaused(paused) {
          if (paused) {
            autoplay.pause();
          } else {
            autoplay.play();
          }
        }

        function updateBottomHoverZone(event) {
          const rect = projectSlider.getBoundingClientRect();
          const inBottomZone =
            event.clientY >= rect.top + rect.height * 0.8 &&
            event.clientY <= rect.bottom &&
            event.clientX >= rect.left &&
            event.clientX <= rect.right;

          if (inBottomZone !== isInBottomHoverZone) {
            isInBottomHoverZone = inBottomZone;
            setAutoplayPaused(inBottomZone);
          }
        }

        projectSlider.addEventListener("mousemove", updateBottomHoverZone);
        projectSlider.addEventListener("mouseleave", function () {
          if (isInBottomHoverZone) {
            isInBottomHoverZone = false;
            setAutoplayPaused(false);
          }
        });
      }
    }

    if ("IntersectionObserver" in window) {
      const sliderObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              initProjectSlider();
              sliderObserver.unobserve(projectSlider);
            }
          });
        },
        { threshold: 0.2 }
      );
      sliderObserver.observe(projectSlider);
    } else {
      initProjectSlider();
    }
  });
})();